import { RootState } from '../types';

const getMaximumStay = (state: RootState) => state.listing.entity?.maximumStay;

export { getMaximumStay };
